export const ANY_ATTRIBUTE_VALUE_PLACEHOLDER = "__any__";
export const DEFAULT_TAX_CLASS_NAME = "_default";
export const LEAVE_PAGE_MESSAGE =
  "Du har ulagrede endringer på denne siden, er du sikker på at du vil forlate den?";
